const Faqs = () => {

    // Fetch all faq accordion headings
    let headings = document.querySelectorAll('[data-question]');

    // Loop through each heading
    Array.from(headings).forEach(heading => {

        // Store the corresponding answer to the question heading
        let target = heading.getAttribute('data-question');

        // If this answer exists, proceed
        if (typeof target != "undefined" && target != null) {

            // Add a click event to the heading
            heading.addEventListener('click', () => {

                // Fetch the element containing the answer
                let content = document.querySelector(`[data-answer="${target}"]`);

                // If we have an answer element, proceed
                if (typeof content != "undefined" && content != null) {
                    // Toggle the open/closed state for this accordion item
                    heading.classList.toggle('open');
                    // Toggle the visibility of the content for this question/heading
                    content.classList.toggle('open');
                }
            });
        }
    });
}

export default Faqs;
